import { useEffect, useState } from 'react';

import HomePhoto from '../../assets/images/Home.png'
import ChevronRight from '../../assets/images/Chevron Right.png'

import { useDispatch } from 'react-redux';
import { setIsLoading, setToastMessage } from "../../reducers/common.reducer";

import { getFundService, getUserInfoService } from '../../services/dashboard.service'

import { getWinLossTotal } from './../../services/winloss.service'



const Dashboard = () => {

  const [fundData, setFundData] = useState([])
  const [userInfo, setUserInfo] = useState([])
  const [totalWinloss, setTotalWinloss] = useState(0);
  const [addingValue, setAddingValue] = useState(48028322.75);
  const [final, setFinal] = useState(0);
  const dispatch = useDispatch();

  const getFundData = async () => {
    dispatch(setIsLoading(true))

    try {
        const result = await getFundService();
        const infoResult = await getUserInfoService();
        if(result.data) {
            setFundData(result.data)
        }
        if(infoResult.data) {
            setUserInfo(infoResult.data)
        }
    }
    catch (error) {
    dispatch(
        setToastMessage({
        message: error?.response?.data?.message || error?.message,
        type: "error",
        })
    );
    }
    finally {
    dispatch(setIsLoading(false))
    }
  }

  useEffect(() => {
    getFundData();
    getTotalWinloss();

  },[]);

  useEffect(()=> {
    setFinal(addingValue* 1 -  totalWinloss *1);
  },[totalWinloss])

  const getTotalWinloss = async () => {

    try {
      const total =await getWinLossTotal();
      //console.log(total);
      setTotalWinloss(total.rows[0].cumulative_winloss);
    }
    catch (error) {
    dispatch(
        setToastMessage({
        message: error?.response?.data?.message || error?.message,
        type: "error",
        })
    );
    }
  }

  let fundInHolder = fundData[0]?.fundInHolder ? fundData[0]?.fundInHolder : 0;
  let remain = fundData[0]?.remainToClaim ? fundData[0]?.remainToClaim : 0;
  let myremain = 0;
  let basicFund = 0;
  if(remain > 0) {
    myremain = remain;
  }
  else {
    myremain = remain * -1;
  }
  basicFund = parseInt(fundInHolder)  + parseInt(myremain);

  // const handleOnChange = (e) => {
  //   setAddingValue(e.target.value);
  //   setFinal(e.target.value* 1 +  totalWinloss *1);
  // }

  basicFund = parseInt(basicFund);
  fundInHolder = parseInt(fundInHolder);
  remain = parseInt(remain);

  let fundInHolderPercentage = (fundInHolder / basicFund) * 100;
  let remainToClaimPercentage = (remain / basicFund) * -100;

  let basicFundPercentage = Math.round(basicFund / basicFund) * 100;
  fundInHolderPercentage = Math.round(fundInHolderPercentage);
  if(fundInHolderPercentage < 0) {
    fundInHolderPercentage = 0;
  }
  remainToClaimPercentage = Math.round(remainToClaimPercentage);

  // Generate Rows for shareHolder
  const shareHolderRows = userInfo?.map(holder => {

    let finalBalanceInHolder = holder.fundInHolder - holder.balanceToClaim;

    return (
    <div className='flex justify-center items-center border-b-2 border-slate-200 py-3 mx-10' key={holder.userId}>
        <div className='flex flex-col sm:flex-row justify-between items-start sm:items-center text-md font-semibold w-full h-full'>
            <h1 className="text-left text-lg sm:text-sm w-[50%] sm:w-[20%]">{(holder.shareHolder).toLocaleString()}</h1>
            <h1 className="text-right w-[50%] sm:w-[20%]">{(Math.round(holder.fundInHolder)).toLocaleString()}</h1>
            <h1 className="text-right w-[50%] sm:w-[20%]">{(Math.round(holder.balanceToClaim)).toLocaleString()}</h1>
            <h1 className="text-right w-[50%] sm:w-[20%]">{(Math.round(finalBalanceInHolder)).toLocaleString()}</h1>
        </div>
    </div>
    )
  })


  return (

    <div className='max-w-6xl w-full mx-auto borderColor h-[88vh] px-2 md:px-4 text-sm'>

      <div className="flex items-center gap-2 pt-2 pb-2">
        <img src={HomePhoto} alt="home-logo" className="w-5 h-5 fgColor" />
        <span className="text-xs font-semibold text-fgColor">Dashboard</span>
      </div>

      {/* Card grid */}
      <div className="mt-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {/* Card Component */}
          <div className="p-4 rounded-xl bg-rectangle border border-gray-100 shadow-sm hover:shadow transition">
            <div className="flex justify-between items-center">
              <div className="flex flex-col gap-2 mb-5">
                <h2 className="text-lg font-semibold text-fgColor">Basic Fund</h2>
                <p className="text-xl font-bold">{basicFund.toLocaleString()}</p>
              </div>
              <p className="text-primary font-bold">{basicFundPercentage}%</p>
            </div>
            {/* Progress Bar */}
            <div className="h-1.5 w-full bg-neutral-200 dark:bg-neutral-600">
              <div className="h-1.5 bg-primary" style={{ width: `${basicFundPercentage}%` }}></div>
            </div>
          </div>

          {/* Card Component */}
          <div className="p-4 rounded-xl bg-rectangle border border-gray-100 shadow-sm hover:shadow transition">
            <div className="flex justify-between items-center">
              <div className="flex flex-col gap-2 mb-5">
                <h2 className="text-lg font-semibold text-fgColor">Fund In Holder</h2>
                <p className="text-xl font-bold">{fundInHolder.toLocaleString()}</p>
              </div>
              <p className="text-attractive1 font-bold">{fundInHolderPercentage}%</p>
            </div>
            {/* Progress Bar */}
            <div className="h-1.5 w-full bg-neutral-200 dark:bg-neutral-600">
              <div className="h-1.5 bg-attractive1" style={{ width: `${fundInHolderPercentage}%` }}></div>
            </div>
          </div>

          {/* Card Component */}
          <div className="p-4 rounded-xl bg-rectangle border border-gray-100 shadow-sm hover:shadow transition">
            <div className="flex justify-between items-center">
              <div className="flex flex-col gap-2 mb-5">
                <h2 className="text-lg font-semibold text-fgColor">Remain to Claim</h2>
                <p className="text-xl font-bold">{remain.toLocaleString()}</p>
              </div>
              <p className="text-red font-bold">{remainToClaimPercentage}%</p>
            </div>
            {/* Progress Bar */}
            <div className="h-1.5 w-full bg-neutral-200 dark:bg-neutral-600">
              <div className="h-1.5 bg-red" style={{ width: `${remainToClaimPercentage}%` }}></div>
            </div>
          </div>

          {/* Card Component */}
          <div className="p-4 rounded-xl bg-rectangle border border-gray-100 shadow-sm hover:shadow transition">
            <div className="flex justify-between items-center">
              <div className="flex flex-col gap-2 mb-5">
                <h2 className="text-lg font-semibold text-fgColor">Agent</h2>
                <p className="text-xl font-bold">{fundData && fundData[0] ? Math.round(fundData[0].totalAgents) : 0}</p>
              </div>
            </div>
            {/* Progress Bar */}
            <div className="h-1.5 w-full bg-neutral-200 dark:bg-neutral-600">
              <div className="h-1.5 bg-slate-500" style={{ width: "100%" }}></div>
            </div>
          </div>



        </div>
      </div>
      <div className="w-full justify-center hidden md:flex">

            <div className="flex justify-center items-center rounded-xl bg-rectangle border border-gray-100 shadow-sm mt-4 w-full transition-shadow duration-300">
              <div className='flex gap-8 items-center p-4'>
                <div className="flex flex-col gap-1">
                  <h2 className="text-sm font-semibold text-fgColor">Total Winloss</h2>
                  <p className="text-lg font-bold bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text text-transparent">{totalWinloss.toLocaleString()}</p>
                </div>
                <div className="flex flex-col gap-1">
                  <h2 className="text-sm font-semibold text-fgColor">Adding Value</h2>
                  <p className="text-lg font-bold bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text text-transparent">{addingValue}</p>
                </div>
                <div className="flex flex-col gap-1">
                  <h2 className="text-sm font-semibold text-fgColor">Final</h2>
                  <p className="text-lg font-bold text-emerald-600">{final}</p>
                </div>
              </div>
            </div>
            {/* Progress Bar */}
          </div>


        {/* ShareHolder section */}
        <div className="mt-4 p-4 bg-rectangle border border-gray-100 rounded-xl shadow-sm px-2 md:px-8">
            <div className='flex justify-center items-center border-b-2 border-slate-400 py-3 mx-8'>
                <div className='flex flex-col sm:flex-row justify-between items-start sm:items-center text-lg font-bold w-full h-full'>
                    <h1 className="">Shareholder</h1>
                    <h1 className="">Fund In Holder</h1>
                    <h1 className="">Need To Claim</h1>
                    <h1 className="">Total Balance</h1>
                </div>
            </div>

            {shareHolderRows}
            <div className="h-8"></div>
        </div>

        <div className="h-8"></div>
    </div>

  )
}

export default Dashboard;
